module.exports = __webpack_public_path__ + "img/icons-general-gift.eed46aea.svg";